<template>
  <div class="pagination-container d-block w-100 mt-6 mb-0">
    <button
      class="pagination-link mr-2 text-center"
      @click="showPreviousPage()"
      :disabled="currentPage <= 1"
    >
      <div class="pagination-arrow-left clickable">
        <span class="mdi mdi-menu-right mdi-24px"></span>
      </div>
    </button>
    <div class="pagination-wrapper-sec">
      <button
        class="pagination-number mx-2 custom-pagination"
        v-for="page in totalPages"
        :key="page"
        @click="showCurrentPage(page)"
        :class="{ active: currentPage === page }"
      >
        {{ page }}
      </button>
    </div>
    <button
      class="pagination-link ml-2"
      @click="showNextPage()"
      :disabled="currentPage >= totalPages"
    >
      <div class="pagination-arrow-right clickable">
        <span class="mdi mdi-menu-right mdi-24px mdi-menu-wrap"></span>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "pagination",

  props: {
    showCurrentPage: Function,
    showPreviousPage: Function,
    showNextPage: Function,
    currentPage: Number,
    totalPages: Number,
  },

  data() {
    return {
      dots: 6,
    };
  },
};
</script>

<style scoped>
.pagination-container {
  content: "";
  text-align: center;
}
.pagination-container * {
  position: relative;
  display: inline-block;
  font-size: 24px;
  text-align: center;
}

.pagination-link {
  font-weight: bold;
  color: black;
}
.pagination-link:hover {
  text-decoration: none;
}
.pagination-link:disabled {
  color: #888888;
}
</style>
